import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const IMPAIRMENT_FILES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('ASSET_TYPES');
export const IMPAIRMENT_FILES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	IMPAIRMENT_FILES_CRUD_ACTION_CONSTANTS
);
